import React, { useEffect, useState } from 'react'
import Modal from '../../components/Modal'
import AdminListScreen from '../../screens/Admin/User/List/admins'

interface Props {
  onSelect: (user: any) => void
  isOpenExternal?: boolean
  setIsOpenExternal?: (open: boolean) => void
}

const UserModal: React.FC<Props> = ({ isOpenExternal, setIsOpenExternal, onSelect }) => {
  const [open, setOpen] = useState(isOpenExternal || false)

  useEffect(() => {
    if (isOpenExternal)
      setOpen(isOpenExternal)
  }, [isOpenExternal])

  useEffect(() => {
    if (setIsOpenExternal)
      setIsOpenExternal(open)
  }, [open])

  return (
    <Modal
      title="Selecione um usuário"
      open={open}
      onToggle={open => setOpen(open)}
    >
      <AdminListScreen
        onSelect={(user) => {
          onSelect(user)
          setOpen(false)
        }}
      />
    </Modal>
  )
}

export default UserModal
